import React, { useState } from 'react';
import avatar from '../../uploads/avatar.png';
import { Image } from 'antd';
const { PhoneNumberUtil, PhoneNumberFormat } = require('google-libphonenumber');

const PersonalInfo = ({ formData }) => {
  
  const imageUrl = formData.Photo ? `data:image/jpeg;base64, ${formData.Photo}` : avatar;
  let birthPlace = `${formData.BirthPlace.Country.Name ? formData.BirthPlace.Country.Name : ''}${formData.BirthPlace.City ? `, ${formData.BirthPlace.City}` : ''}`;
  
  return (
    <div>
      <table>
        <tbody>
          <tr>
            <th colSpan="4" className="bg">
              <p className='center'>{formData.Name}</p>
            </th>
          </tr>
          <tr>
            <td width="25%" colSpan={2}>
              <p className="title">Дата рождения: {formData.BirthDate}</p>
            </td>
            <td width="45%">
              <p className="title">Место рождения: {birthPlace}</p>
            </td>
            <td width="20%" rowSpan="6" style={{ padding: '0' }}>
              <div style={{ margin: '0 auto', width: '90%' }}>
                <label htmlFor="avatar">
                  <Image preview={{ mask: 'Просмотр' }} id="avatar-img" src={imageUrl} style={{ width: '100%', aspectRatio: '3/4' }} alt="" />
                </label>
              </div>
            </td>
          </tr>
          <tr>
            <td colSpan={'2'}>
              <p className="title">Национальность: {formData.Nationality.Name}</p>
            </td>
            <td>
              <p className="title">Гражданство: {formData.Citizenship.Name}</p>
            </td>
          </tr>
          <tr>
            <td colSpan={'2'}><p className="title">Паспортные данные:</p></td>
            <td><p style={{ marginRight: "10px" }}>{`${formData.Passport.type.Name ? formData.Passport.type.Name : ''} ${formData.Passport.DocSeries ? formData.Passport.DocSeries : ''} ${formData.Passport.DocNumber ? formData.Passport.DocNumber : ''} выдан ${formData.Passport.DocIssued ? formData.Passport.DocIssued : ''} ${formData.Passport.DocDateIssued ? formData.Passport.DocDateIssued : ''}, действует до ${formData.Passport.DocValid ? formData.Passport.DocValid : ''}`}</p></td>
          </tr>
          <tr>
            <td width={'25%'}><p className="title">Семейное положение:</p></td>
            <td colSpan={'2'}>
              <p>{formData.MaritalStatus.Name}</p>
            </td>
          </tr>
          <tr>
            <td><p className="title">Email:</p></td>
            <td colSpan={'2'}><p>{formData.EmailPersonal}</p></td>
          </tr>  
          <tr>
            <td><p className="title">Контактные телефоны:</p></td>
            <td colSpan={'2'}><p>{formData.MobilePhonePersonal.value}</p></td>
          </tr>  
        </tbody>
      </table>
    </div>
  );
};

export default PersonalInfo;
